import { Injectable } from "@angular/core";
import { EntityUIQuery, QueryEntity } from "@datorama/akita";
import { ProjectCategoryState, ProjectCategoryStore, ProjectCategoryUIState } from "./projectCategory.store";
import { map } from "rxjs/operators";
import { EProject, ProjectVisibilityQuery } from "../projectVisibilityQuery";
import { combineLatest } from "rxjs";
import { IProjectCategory } from "@common/interfaces/projectCategory";

export interface IProjectCategoryWithProj extends IProjectCategory {
  projects: EProject[],
}

@Injectable({
  providedIn: 'root'
})
export class ProjectCategoryQuery extends QueryEntity<ProjectCategoryState> {
  ui: EntityUIQuery<ProjectCategoryUIState>;

  constructor(
    protected store: ProjectCategoryStore,
    private projectVisibilityQuery: ProjectVisibilityQuery,
  ) {
    super(store);
    this.createUIQuery();
  }

  // Include anche le categorie senza nome (cioè -> '', che è una categoria unica per i progetti senza categoria associata)
  categories$ = combineLatest([this.selectAll(), this.projectVisibilityQuery.projects$]).pipe(
    map(([cats, projects]) => {
      let initialObj: { [key: string]: Partial<IProjectCategoryWithProj> } = {};
      // Costruisco un oggetto iniziale perché voglio popolarlo anche con le categorie che non hanno progetti.
      for (const cat of cats) {
        initialObj[cat.id] = { ...cat, projects: [] };
      }
      const res = projects.reduce<{ [key: string]: Partial<IProjectCategoryWithProj> }>((acc, curr) => {
        let category: IProjectCategory;
        if (!!curr.categoryId) {
          category = cats.find(cat => cat.id === curr.categoryId);
          // Dovrebbe trovarlo sempre, essendo "categoryId" una chiave esterna di ProjectCategory, a meno che quella categoria è stata eliminata: a quel punto il
          // find() non trova nulla (per ora il sistema non setta a null il categoryId del progetto quando la sua categoria viene soft-eliminata).
        }
        if (!category) {
          if (!acc['']) {
            acc[''] = { projects: [] };
          }
          acc[''].projects.push(curr);
        } else {
          acc[curr.categoryId].projects.push(curr);
        }

        return acc;
      }, initialObj);
      let arrayRes: Partial<IProjectCategoryWithProj>[] = [];
      for (const key in res) {
        arrayRes.push(res[key]);
      }
      return arrayRes;
    }),
  );
}
